{
	"buttons": {
		"all_presets": "All packages",
		"clear_filters": "Clear filters",
		"download_diploma": "Download diploma",
		"select_topic": "Course categories",
		"presets": "Course packages",
		"search": "Search",
		"clear": "Clear",
		"signin": "Sign in",
		"start_playlist": "Start playlist",
		"open_prescription": "Open prescription",
		"close_popup": "Close popup",
		"open_course_page": "Open course page",
		"close": "Close",
		"will_learn": "You will learn how to…",
		"show_completed": "Show completed",
		"hide_completed": "Hide completed",
		"open_course": "Open course",
		"choose_course": "Choose course",
		"wishlist_all": "All saved courses",
		"all_courses": "All courses",
		"all_on_topic": "All on topic",
		"all_recommended_programms": "All recommended programms",
		"all_required_programms": "All required programms",
		"prescription_all": "All assigned programs",
		"assign": "Assign",
		"assign_all": "Assign to all",
		"send": "Send",
		"sending": "Sending",
        "cancel": "Cancel",
		"notify_all": "Remind everyone",
		"add_file": "+ Add file",
		"reset": "Reset",
		"collapse_menu": "Collapse menu",
		"open_menu": "Open menu",
		"show_more": "Show more",
		"show_less": "Show less",
		"apply": "Аpply",
		"save": "Save",
		"add_course": "Add course",
		"add_career": "Add career",
		"open": "Open",
		"edit": "Edit",
		"download_statistics": "Download statistics",
		"copy_course": "Copy course",
		"recommend_courses": "Recommend courses",
		"copy": "Copy",
		"learn_more": "Learn more",
		"wished": "Selected courses",
		"all_my_courses": "All my courses"
	},
	"course_types": {
		"all": "All types",
		"audition": "Sales Simulation",
		"business_case": "Business Case",
		"competences": "Test",
		"dialog": "Dialogue Simulation",
		"educational_materials": "Educational material",
		"graduation_project": "Graduation project",
		"interview": "Interview",
		"long": "Video course",
		"longread": "Longread",
		"materials": "Materials",
		"presentation": "Presentation",
		"quiz": "Quiz",
		"short": "Mini-course",
		"summary": "Summary of the book",
		"test": "Test",
		"playground": "Practice in a code editor",
		"practical_task": "Practical task",
		"scorm": "SCORM",
		"podcast": "Podcast"
	},
	"deadlines": {
		"late": "expired",
		"finished": "completed",
		"current": "Left",
		"continue": "Continue",
		"last_day": "ends today",
		"completed": "Completed"
	},
	"placeholders": {
		"courses_search_placeholder": "What do you want to learn today?",
		"your_name": "Your name",
		"phone": "Phone",
		"your_answer": "Your answer",
		"your_answer_homework": "Your answer"
	},
	"duration": {
		"h": " h.",
		"min": " min."
	},
	"messages": {
		"no_filters_message": "Nothing found with these filters. Try resetting them.",
		"mute_message": "Click to turn the sound on.",
		"no_diplomas_message":"You don't have any completed courses yet.",
		"start_your_learning_path": "There's nothing here yet. Start learning by choosing a course from the catalog",
		"choose_description": "Choose any of the hundreds interactive courses and simulations",
		"no_training": "No training was planned.",
		"no_recommended_training": "Recommended training was not assigned.",
		"megafon_1": "No training was planned as part of the 360 assessment development.",
		"megafon_2": "You have access to common programs from the library",
		"recommended_megafon_1": "You are not assigned any mandatory training.",
		"recommended_megafon_2": "You have access to common programs from the library",
		"no_wished_plan": "There are no courses here yet. Add courses from the catalog by clicking the heart",
		"term_and_privacy": "By registering I hereby acknowledge that I have read the Eduson <a href=\"https://downloads.eduson.tv/pdf/eduson-privacy.pdf\" target=\"_blank\">Terms of Use</a> and EDUSON LLC may collect, use, transfer and information for the following purposes: <ul class=\"privacy-list\"><li>To generate reports and analyses after my completion of EDUSON LLC content and other services;</li><li>To provide educational information related to EDUSON LLC content and services. </li></ul>",
		"mega_term_and_privacy": "By registering I hereby acknowledge that I have read the Eduson <a href=\" https://downloads.eduson.tv/materials/files/000/005/732/original/Term_mega.pdf\" target=\"_blank\">Terms of Use</a> and EDUSON LLC may collect, use, transfer and information for the following purposes: <ul class=\"privacy-list\"><li>To generate reports and analyses after my completion of EDUSON LLC content and other services;</li><li>To provide educational information related to EDUSON LLC content and services. </li></ul>",
		"select_file": "Click or drag the file to the upload area",
		"answer_received_prefix": "Your answer has been received for review. Wait for the curator's response. Please note that you have",
		"answer_received_suffix": "0 attempts. | {count} attempt. | {count} attempts. | {count} attempts.",
		"homework_attempt_error_prefix": "Your answer was not accepted. Please revise the assignment and submit it again. Please note that you have",
		"homework_attempt_error_suffix": "0 attempts. | {count} attempt. | {count} attempts. | {count} attempts.",
		"homework_accepted": "Congratulations! You have successfully completed the assignment.",
		"homework_attempt_limit_reached": "Your answer was not accepted. Unfortunately, you have exhausted all your submission attempts for the assignment. Don’t worry—these things happen! Please contact your curator to determine the next steps.",
		"end_time": "Until the end of the trial period",
		"list_is_empty": "The list is empty",
		"homework_callout": "Please upload only fully completed work. Before submitting the assignment, make sure it’s accessible and opens correctly."
	},
	"days": "no days | 1 day | {n} days",
	"minutes": "0 minutes | {n} minute | {n} minutes",
	"hours": "0 hours | {n} hour | {n} hours",
	"seconds": "0 secundes | {n} secund | {n} secundes",
	"hours_of_training": "0 hours of training | {n} hour of training | {n} hours of training",
	"courses": "0 courses | {n} course | {n} courses",
	"today": "Today",
	"left": "left",
	"in": "in",
	"assignment": "Assignment",
	"filters": "Filters",
	"similar_courses": "Similar courses",
	"with_diploma": "With diploma",
	"learning_plan": "Learning plan",
	"completed_on": "Completed on",
	"learning_plan_completed_to": "Learning plan completeness",
	"recommended_programms": "Recommended programms",
	"condidate_learning_plan": "Testing the candidate",
	"condidate_learning_plan_completed_to": "Candidate testing completed",
	"megafon_plan": "Required courses",
	"megafon_plan_completed_to": "Required courses completeness",
	"recommended_megafon_plan": "Recommended courses for the 360 Assessment Development Program",
	"presets": "Course packages",
	"catalog": "Catalog",
	"have_an_account": "Already have an account?",
	"progress": "Progress",
	"timecodes": "Timecodes",
	"where_to_begin": "Where to start...",
	"wish_courses": "Saved courses",
	"new_courses": "New courses",
	"full_only": "Only in full version",
	"started": "Started",
	"sales_courses": {
        "cold_call": {
			"title": "Cold Calling Simulator",
			"description": "<p class='sales-type-description'>Sales reps listen to dozens of pre-recorded sales conversations and choose the best ways to pass the gatekeeper, to handle objections, and to close the sale.</p> <p class='sales-type-description'>When they meet an angry customer or hear the “call me later” objection in real situations, they are now prepared to react professionally and will remember what to say even in the toughest conversation.</p>"
		},
        "video_rehearsal": {
			"title": "Video Role-play Tool to Rehearse",
			"description": "<p class='sales-type-description'>Practice makes perfect. Record a series of videos with typical customer questions.</p> <p class='sales-type-description'>Then analyze the sales reps' video answers and provide feedback. Role-playing allows the student to train in a safe environment until the needed negotiating skills become second-nature and the rep is ready to face the customer.</p>"
		},
        "speech_recognition": {
			"title": "Speech Recognition Training Tool",
			"description": "<p class='sales-type-description'>Most sales reps suffer from “sales amnesia”.</p> <p class='sales-type-description'>Tell them something on Monday, and they forget it by Friday. It is curable now. Our training courses make salespeople repeat each phrase aloud a dozen times while training, again and again, until they get it word-perfect.</p> <p class='sales-type-description'>Eduson’s speech recognition technology won't accept incorrect answers.</p>"
		},
        "title": "Sales Training",
        "sub_title": "155 interactive training tools for sales reps and call center agents"
	},
	"used_license": "Licenses used",
	"active_till": "Active till",
	"contact_soon": "We will contact you soon",
	"employees_without_appointments": "Employees without assignments",
	"avg_count_assignments": "You have {avg_yours} assignments per employee, the average for your industry is {avg_total}",
	"overdue_appointments": "Assignments overdue",
	"notification_send": "Reminders are sent.",
	"check_them": "You can remind again",
	"sending_notification": "Sending notifications",
	"going_to_send": "You're going to send",
	"notifications": "0 notification | {n} notifications | {n} notifications | {n} notifications",
	"license_popup": {
		"title": "License acquiring application",
		"submit": "Send request",
		"message": "Our manager will contact you to discuss additional licenses for your employees.",
		"invite": "Invite",
		"purchase_licenses": "Purchase licenses"
	},
	"homework": "Homework",
	"checking_homework": "Checking homework",
	"homework_files": "Homework files",
	"homework_statuses": {
		"sent": "Pending review",
		"checking": "Under review",
		"wait_crosscheck": "Waiting for cross-check",
		"in_crosscheck": "In cross-check",
		"recheck": "Being revised",
		"success_done": "Successfully completed",
		"failed_done": "Not completed",
		"archived": "Archived"
	},
	"hide_completed_homework_attempts": "Hide completed",
	"curators_response": "Curator's response",
	"welcome_partners_title": "Leading companies trust Eduson.tv to train their employees",
	"welcome_why_eduson_title": "Training managers and company employees are satisfied with working with Eduson",
	"types_of_courses": "Types of courses",
	"subjects": "Subjects",
	"sorting": {
		"new_first": "New ones first",
		"sorting_AZ": "Alphabetically from A to Z",
		"sorting_ZA": "Alphabetically from Z to A",
		"popular": "Popular"
	},
	"found": "Found",
	"hide_completed_courses": "Hide completed courses",
	"show_wished_courses": "Show wished courses",
	"roles": {
		"super_admin": "super admin",
		"expert": "expert",
		"department_admin": "department admin",
		"company_head": "company head",
		"user": "user"
	},
	"appointed_by": "Appointed by",
	"appointment_date": "Appointment date",
	"status": "Status",
	"start": "Start",
	"anonymous_survey": "Anonymous survey",
	"popular_presets": "Collections of popular courses",
	"recommended_courses": "Recommended courses",
	"all_recommended_courses": "All recommended courses",
	"languages": {
		"ru": "Русский",
		"en": "English"
	},
	"publications": {
		"all": "All",
		"published": "Published",
		"unpublished": "Unpublished"
	},
	"total_courses": "Total courses",
	"total_careers": "Total careers",
	"type": "Type",
	"no_name": "No name",
	"referral": {
		"do_you_like_studying_at_Eduson": "Do you like studying at Eduson?",
		"recommend_your_courses": "Recommend your courses and get paid for that!",
		"get_referral_link": "Get referral link",
		"copy_referral_link": "Copy referral link",
		"get_paid": "Get paid"
	},
	"unload_page_popup": {
		"title": "Wait!",
		"text_1": "You are doing great! Please give yourself a chance to learn all the important points before you leave.",
		"text_2": "Are you sure you want to leave this page?",
		"yes": "Yes",
		"no": "No, continue studying"
	},
	"audio": {
		"skip_back_15": "Back 15 sec",
		"skip_forward_15": "Forward 15 sec"
	}
}
